import React, { FC, Fragment } from 'react';

export interface TableHeadDataProps {
  [key: string]: any;
}
interface TableRowProps {
  selectedFields: string[];
  data: TableHeadDataProps[];
}

const TableRow: FC<TableRowProps> = ({ data, selectedFields }) => {
  return (
    <Fragment>
      {data.map((row, index) => {
        const filteredData = Object.keys(row)
          .filter((key) => selectedFields.includes(key))
          .reduce((obj: any, key: any) => {
            obj[key] = row[key];
            return obj;
          }, {});

        return (
          <tr key={index}>
            {Object.keys(filteredData).map((keyName, i) => (
              <td key={i}>{row[keyName]}</td>
            ))}
          </tr>
        );
      })}
    </Fragment>
  );
};

export default TableRow;
